import React from "react";
import { Radio } from "antd";
import FormulaRenderer from "../../../../../../../math-formula";

function TrueOrFalse({ data }: any) {
return (
    <div className={`choose-correct`}>
      <div className="flex flex-column gap-12">
        {data?.questions &&
          data?.questions?.length > 0 &&
          data?.questions?.map((quiz: any, index: number) => (
            <Radio key={quiz?.uuid + index} checked={quiz?.isTrue}>
              <div
                className={`${
                  quiz?.isTrue && "text-result"
                } font-size-16 line-height-24 font-weight-5`}
              >
                <FormulaRenderer
                  className="ml-1"
                  htmlString={quiz?.content || "N/A"}
                />
              </div>
            </Radio>
          ))}
      </div>
    </div>
  );
}

export default TrueOrFalse;
